import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import utils from 'helpers/utils';
import ToolbarWrapper from 'components/templates/Wrappers/Toolbars/ToolbarWrapper/ToolbarWrapper';

const StyledSettingsHeaderWrapper = styled(ToolbarWrapper)
  .attrs((props) => {
    let attr = props;

    const vars = {
      '--settings-header-wrapper-bounds-top': props.$wrapper?.boundsCum?.top ?? '0px',
      '--settings-header-wrapper-bounds-bottom': props.$wrapper?.boundsCum?.bottom ?? '0px'
    };

    return utils.styleProps(attr, vars);
  })`
  min-height: calc(100vh - (${props => props.$css.$var('--settings-header-wrapper-bounds-top')} + ${props => props.$css.$var('--settings-header-wrapper-bounds-bottom')}));

  .HeaderBar {
    height: fit-content;
    border-bottom: unset;
    background-color: unset;
    
    .PageBar {
      &-toolbar {
        height: fit-content;
        padding: 0 !important;
      }
      &-center-wrapper {
        width: 100%;
        flex: unset;
        left: 0;
        position: relative;
      }
    }
  }

  ${props => props.theme.breakpoints.down('md')} {
    .SettingsHeader {
      &-search {
        max-width: unset;
        min-width: unset;
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledSettingsHeaderWrapper.propTypes = {
  theme: PropTypes.object
};

export default StyledSettingsHeaderWrapper;
